module.exports = __webpack_public_path__ + "static/media/l-md14.c18b5bca.png";